import { render, staticRenderFns } from "./RemoveAssigneeConfig.vue?vue&type=template&id=1ad3b1a8&scoped=true"
import script from "./RemoveAssigneeConfig.vue?vue&type=script&lang=js"
export * from "./RemoveAssigneeConfig.vue?vue&type=script&lang=js"
import style0 from "./RemoveAssigneeConfig.vue?vue&type=style&index=0&id=1ad3b1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3b1a8",
  null
  
)

export default component.exports